import { theme } from 'antd'
import { CellValidator, ValidationResult } from '../helpers/cell-validators'
import CalculationPosition from '../types/api/calculation-position'
import Shipment from '../types/api/shipment'

export const useCellValidation = (
    validator: CellValidator | undefined,
    record: CalculationPosition | Shipment
): ValidationResult | null => {
    const { token } = theme.useToken()

    if (!validator) {
        return null
    }

    if (record.shipmentType === 'colorProof') {
        return null
    }

    return validator(record, token)
}
